module.exports = __webpack_public_path__ + "static/media/step-three-small.ad4576d4.webp";